

module.directive('studentRenameForm', function(ModelService, autoSortNameFilter) {
    return {
        restrict: 'E',
        templateUrl: 'students/demographics/studentRenameForm',
        scope: {participant: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = ModelService.copyFields(scope.participant, [
                'student_name', 'sort_name']);
            basicForm.data = scope.data;
            scope.form = basicForm.getForm();

            scope.customSort = scope.data.sort_name !== autoSortNameFilter(
                scope.data.student_name);

            scope.overrideSort = function(sort_name) {
                scope.customSort = true;
                scope.data.sort_name = sort_name;
            };

            scope.useDefaultSort = function() {
                scope.customSort = false;
                scope.data.sort_name = undefined;
            };

            basicForm.save = function(data) {
                if (!scope.customSort) {
                    data.sort_name = null;
                }
                return ModelService.patchModel(scope.participant, data);
            }
        }
    }
});